import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconChevronDown';
/** Renders an SVG icon. */
const SvgChevronDown = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8.204 12.204a1.126 1.126 0 0 1 1.591 0L16 18.41l6.204-6.204a1.125 1.125 0 0 1 1.591 1.59l-7 7c-.439.44-1.151.44-1.59 0l-7-7a1.125 1.125 0 0 1 0-1.59Z"
      />
    </svg>
  );
};
SvgChevronDown.displayName = displayName;
export default SvgChevronDown;
